// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__FkTcS","move":"Loader_move___h5hj","rotate":"Loader_rotate__bVLvB"};